import "bootstrap/js/dist/collapse";

/**
 * Custom collapse behaviour has to be altered via JS.
 *
 * @return {void}
 */
export function useCollapse() {
    $(document).on("show.bs.collapse", ".collapse", function () {
        const toggle = $(`[href='#${$(this).attr("id")}']`).closest(".nav-item");
        if (toggle.length) {
            // there is a reason for this retarded name, active adds some styles
            toggle.addClass("activated");
            toggle.parent().addClass("activated");
            return true;
        }
    });

    $(document).on("hide.bs.collapse", ".collapse", function () {
        const toggle = $(`[href='#${$(this).attr("id")}']`).closest(".nav-item");
        if (toggle.length) {
            // there is a reason for this retarded name, active adds some styles
            toggle.removeClass("activated");
            if (toggle.parent().find(".activated").length == 0) {
                toggle.parent().removeClass("activated");
            }
            return true;
        }
    });

    $(document).on("show.bs.tab", ".nav-tabs a", function () {
        const toggle = $(this).closest(".nav-item");
        if (toggle.length) {
            // there is a reason for this retarded name, active adds some styles
            toggle.addClass("activated");
            toggle.parent().addClass("activated");
            return true;
        }
    });

    $(document).on("hide.bs.tab", ".nav-tabs a", function () {
        const toggle = $(this).closest(".nav-item");
        if (toggle.length) {
            // there is a reason for this retarded name, active adds some styles
            toggle.removeClass("activated");
            if (toggle.parent().find(".activated").length == 0) {
                toggle.parent().removeClass("activated");
            }
            return true;
        }
    });
}
